<template>
  <div class="home_box">
    <div class="en_box" v-if="$i18n.language == 'en'">
      <img src="../assets/images/about_en.jpg" alt="" />
    </div>
    <div class="about_page" v-else>
      <div class="banner">
        <img src="../assets/images/企业简介_02.jpg" alt="" />
      </div>
      <div class="btn_box">
        <div class="btn_body">
          <div class="btns">
            <div
              class="btn"
              :class="tabIndex === item ? 'btn_act' : ''"
              v-for="(item, index) in btns"
              :key="index"
              @click="changeTab(item)"
            >
              {{ $t(item) }}
            </div>
          </div>
          <div class="goback">
            <span @click="goback()">{{ $t("about.backToHome") }}</span> >
            <span> {{ $t("nav.about") }}</span>
          </div>
        </div>
      </div>
      <!-- 创始人寄语 -->
      <div class="csrjy_box" v-show="tabIndex === 'about.founderMessage'">
        <img src="../assets/images/企业简介_04.jpg" alt="" />
        <img src="../assets/images/企业简介_05.jpg" alt="" />
      </div>
      <div class="gsjs_box" v-show="tabIndex === 'about.companyIntro'">
        <div class="jjkyljt_box">
          <img src="../assets/images/企业简介_06.jpg" alt="" />
          <img src="../assets/images/企业简介_07.jpg" alt="" />
        </div>
        <div class="jcsqyl_box">
          <div class="title">{{ $t("about.basicCommunityHealth") }}</div>
          <div class="jcsqyl_body">
            <div class="time_box">
              <div
                class="time"
                :class="timeIndex === index ? 'time_act' : ''"
                v-for="(item, index) in timeList"
                :key="index"
                @click="changeTime(item, index)"
              >
                {{ item.time }}
              </div>
            </div>
            <div class="tips_box">
              <div class="title1">{{ list[timeIndex].title }}</div>
              <div class="tips">{{ list[timeIndex].tips }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="qywh_box" v-show="tabIndex === 'about.companyCulture'">
        <!-- 企业理念 -->
        <div class="qyln_box">
          <img src="../assets/images/qywh_title.png" alt="" />
          <img src="../assets/images/qywh_img1.png" alt="" />
        </div>
        <!-- 三道文化 -->
        <div class="sdwh_box">
          <div class="title1">{{ "三道文化" }}</div>
          <div class="img_list">
            <div class="img">
              <img src="../assets/images/td_img.png" alt="" />
              <div class="text_box">
                <div class="title1">{{ $t("about.tianDao") }}</div>
                <div class="tips">{{ $t("about.tianDao.desc") }}</div>
              </div>
            </div>
            <div class="img">
              <img src="../assets/images/sd_img.png" alt="" />
              <div class="text_box">
                <div class="title1">{{ $t("about.shiDao") }}</div>
                <div class="tips">{{ $t("about.shiDao.desc") }}</div>
              </div>
            </div>
            <div class="img">
              <img src="../assets/images/xd_img.png" alt="" />
              <div class="text_box">
                <div class="title1">{{ $t("about.xiaoDao") }}</div>
                <div class="tips">{{ $t("about.xiaoDao.desc") }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 标杆文化 -->
        <div class="bgwh_box">
          <img src="../assets/images/qywh_img2.png" alt="" />
          <img src="../assets/images/qywh_img3.png" alt="" />
          <img src="../assets/images/qywh_img4.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "about",
  data() {
    return {
      tabIndex: "about.founderMessage",
      btns: [
        "about.founderMessage",
        "about.companyIntro",
        "about.companyCulture",
      ],
      timeIndex: 0,
      list: [
        {
          time: "2002 年",
          title: "正式起航",
          tips: "公司的第一个经营体：民生堂药店注册成立。标志着佳家康医疗集团正式起航。",
        },
        {
          time: "2004 年",
          title: "第二家单位成立",
          tips: "第二家单位：民仁堂药店成立。",
        },
        {
          time: "2005 年",
          title: "响应国家号召，实现转型",
          tips: "国家提出'大病进医院，小病进社区'的口号。我国开始了城镇医疗卫生改革，大力发展社区卫生服务机构。公司抓住历史时机，建立第一家医院——青岛市李沧区浮山路街道民安康社区卫生服务站，实现从药店经营到社区医院经营的转型。",
        },
        {
          time: "2006 年",
          title: "推行医疗改革",
          tips: "青岛市推行医疗改革，民安康社区卫生服务站成为青岛市首批医保定点单位。",
        },
        {
          time: "2007 年",
          title: "首批民营社区卫生服务中心",
          tips: "第二家医院--青岛市李沧区虎山路街道社区卫生服务中心成立。并成为首批承担国家公共卫生项目的民营社区卫生服务中心，被李沧区卫生局指定为社区卫生服务中心示范单位。自此公司确立了社区医院连锁经营的模式。",
        },
        {
          time: "2008 年",
          title: "被评为'国医示范门诊'",
          tips: "青岛市李沧区积极响应国家大力发展中医药政策的号召被评为国家级中医示范区，虎山路街道社区卫生服务中心被评为国医示范门诊。第三家医院--青岛市李沧区虎山路街道虎山花苑社区卫生服务站成立",
        },
        {
          time: "2008 年",
          title: "2008 年快速复制",
          tips: "3 月，第十家医院 - 青岛市李沧区沧口街道永定路社区卫生服务中心成立。5 月，第十一家医院 - 青岛佳家康健康管理有限责任公司城阳综合门诊部开业。8 月，第十二家医院 - 青岛市城阳区城阳街道正阳路社区卫生服务中心成立，成月锡潮区卫生局引进的首家民营社区卫生服务中心。12 月，第十三家医院 - 青岛佳家康健康管理有限责任公司市南门诊部成立。",
        },
        {
          time: "2010 年",
          title: "第四家医院成立",
          tips: "虎山路社区卫生服务中心数字化预防接种门诊开业。第四家医院--青岛市李沧区浮山路街道河东社区卫生服务站成立。",
        },
        {
          time: "2011 年",
          title: "佳家康商标注册成功",
          tips: "佳家康商标注册成功，开启打造佳家康品牌。第五家医院--青岛市李沧区九水街道佳家康社区卫生服务中心成立。",
        },
        {
          time: "2012 年",
          title: "成功注册青岛佳家康健康管理有限责任公司",
          tips: "成功注册青岛佳家康健康管理有限责任公司。第六家医院--青岛市李沧区沧口街道永年路社区卫生服务站成立。",
        },
        {
          time: "2014 年",
          title: "实现电子化运营",
          tips: "导入 HIS 医院信息管理系统，实现电子化运营。第七家医院--青岛市崂山区中韩街道海大麦岛社区卫生服务站成立。第八家医院--青岛市崂山区佳家康门诊部成立。第九家医院--青岛市崂山区中韩街道石岭社区卫生服务站成立。",
        },
        {
          time: "2015 年",
          title: "多家医院相继成立",
          tips: "第十家医院--青岛市李沧区沧口街道永定路社区卫生服务中心成立。第十一家医院--青岛佳家康健康管理有限责任公司城阳综合门诊部开业。第十二家医院--青岛市城阳区城阳街道正阳路社区卫生服务中心成立。成为城阳区卫生局引进的首家民营社区卫生服务中心。第十三家医院--青岛佳家康健康管理有限责任公司市南门诊部成立。",
        },
        {
          time: "2016 年",
          title: "持续向好发展",
          tips: "第十四家医院--崂山区中韩街道松竹新村社区卫生服务站并购成功。浮山路街道河东社区卫生服务站迁址，面积扩大到 400 平。第十五家医院--黄岛区隐珠街道佳家康社区卫生服务中心成立。第十六家医院--佳家康市北门诊部并购成功。",
        },
        {
          time: "2017 年",
          title: "快速发展",
          tips: "第十七家医院--即墨佳家康社区卫生服务中心成立。第十八家医院--青岛市城阳区城阳街道荟城路社区卫生服务中心成立。第十九家医院--青岛市黄岛区长江路街道佳家康社区卫生服务中心成立。第二十家医院--崂山佳家康妇儿门诊部成立。第二十一家医院--李沧区浮山路街道旭东社区卫生服务站并购成功。第二十二家医院--青岛市李沧区虎山路街道社区卫生服务中心 (时代城院) 成立。第二十三家医院--李沧区浮山路街道民安康社区卫生服务站 (鼎世华府院) 成立。第二十四医院--市北区浮山新区街道湖光山色社区卫生服务站顺利并购运营。",
        },
        {
          time: "2018 年",
          title: "快速发展",
          tips: "第二十五家医院--青岛市南香港中路街道南京路社区卫生服务中心成立。",
        },
        {
          time: "2019 年",
          title: "肯定与认可",
          tips: "佳家康医疗集团顺利通过国家标准化中期评估，集团在质量管理和服务质量方面的建设得到了国家标准化管理委员会评委的认可与肯定。第二十六家医院--青岛市城阳区夏庄街道夏塔路社区卫生服务中心成立。第二十七家医院--青岛市李沧区浮山路街道中海社区卫生服务中心成立。",
        },
        {
          time: "2020 年",
          title: "国家级服务业标准化试点项目",
          tips: "国家级服务业标准化试点项目：青岛佳家康社区健康服务标准化试点正式通过验收，实现了李沧区服务业领域标准化项目零的突破。集团取得互联网医院资质，加快建立线上线下一体化的医疗服务新模式。第二十八家医院--青岛市市北区四方街道金华路佳家康社区卫生服务中心成立。第二十九家医院--青岛市城阳区城阳街道明阳路社区卫生服务站成立。",
        },
        {
          time: "2021 年",
          title: "启动数字化建设",
          tips: "集团启动以顾客需求为导向的数字化建设。以中医特色的家庭医生模式为基础，通过流程化、信息化路径实施，打造医生端、居民端、管理端相结合的新体系。第三十家医院--青岛市市北区双山街道佳家康社区卫生服务中心成立。第三十一家医院--青岛市莱西梅山路综合门诊部成立。第三十二家医院---胶州慈云诊所并购成功。第三十三家医院---胶州骏骊诊所并购成功。第三十四家医院---胶州临溪诊所并购成功。第三十五家医院---胶州欣康诊所并购成功。",
        },
        {
          time: "2022 年",
          title: "通过岛市标准化示范项目验收",
          tips: "集团参与青岛市标准化示范项目高分通过验收。虎山路社区卫生服务中心优质服务基层行验收通过。第三十六家医院--青岛市李沧区浮山路街道浮山路社区卫生服务中心成立。第三十七家医院--青岛市市北区湖岛街道佳家康社区卫生服务中心成立。",
        },
        {
          time: "2023 年",
          title: "稳步发展",
          tips: "第三十八家医院--青岛佳家康医疗管理有限公司第四十一综合门诊部 (小寨子院) 成立。第三十九家医院--青岛佳家康医疗管理有限公司第三十九诊所 (下街院) 成立第四十家医院--青岛市李沧区沧口永平路社区卫生服务站成立。第四十一家医院--佳家康胶州众平诊所成立。",
        },
        {
          time: "2024 年",
          title: "开启'双城时代'",
          tips: "集团被评为中国社区卫生协会社会办分会常务副会长单位'佳有好医'2.0 版即时送药正式上线，实现就医零距离，让每个家庭都能享受到专业的医疗服务。济南市首家佳家康社区医疗祝舜路综合门诊部开业。标志着集团开启'双城时代'。青岛市李沧区虎山路街道社区卫生服务中心被评选为社区医院。本年度新开 13 家新院。",
        },
        {
          time: "2025 年",
          title: "数字化转型",
          tips: "本年度，集团全面加速数字化转型，旗下60余家机构实现全流程智慧化运营，通过智能预约、远程诊疗、健康数据互联互通，大幅提升服务效率与患者体验。同时，集团正式焕新企业愿景：致力于成为居民就医的首选信赖之选，为每一位员工搭建实现自我价值的成长平台，并矢志不渝地专注于医疗健康管理领域，锚定百年品牌发展目标，深耕社区、守正创新。至此，集团以科技赋能服务、以使命引领方向，正稳步构建覆盖更广、响应更快的基层医疗生态，让优质医疗资源真正触手可及。",
        },
      ],
    };
  },
  computed: {
    timeList() {
      return this.list.reverse();
    },
  },
  mounted() {},
  methods: {
    goback() {
      this.$router.push("/Home");
    },
    changeTab(item) {
      this.tabIndex = item;
    },
    changeTime(item, index) {
      this.timeIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.home_box {
  width: 100%;
  height: 100%;
  .en_box {
    width: 100%;
    height: auto;
    margin-top: -110px;
    box-sizing: border-box;
    img {
      width: 100%;
      height: auto;
    }
  }
}
.about_page {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  .banner {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }

  .btn_box {
    width: 100%;
    height: 64px;
    background-color: #f0f1f5;

    .btn_body {
      width: 100%;
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btns {
        width: 50%;
        height: 64px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .btn {
          width: auto;
          padding: 5px 10px;
          box-sizing: border-box;
          background-color: rgba(255, 255, 255, 1);
          margin-right: 15px;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;

          &:hover {
            transition: all 0.3s;
            box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
          }
        }

        .btn_act {
          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
        }
      }

      .goback {
        width: auto;
        height: 64px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        span {
          cursor: pointer;

          &:last-child {
            font-weight: bold;
          }
        }
      }
    }
  }

  .csrjy_box {
    width: 100%;
    height: auto;
    min-height: 100vh;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }

  .gsjs_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    .jjkyljt_box {
      width: 100%;
      height: auto;
      box-sizing: border-box;

      img {
        width: 100%;
        height: auto;
      }
    }

    .jcsqyl_box {
      width: 100%;
      min-height: 500px;
      background-color: #e8fbff;
      padding: 50px 0;
      box-sizing: border-box;

      .title {
        width: 100%;
        max-width: 1400px;
        margin: 0 auto;
        margin-bottom: 30px;
        font-size: 40px;
        text-align: start;
      }

      .jcsqyl_body {
        width: 100%;
        max-width: 1400px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .time_box {
          width: 100px;
          height: 400px;
          overflow-y: scroll;
          box-sizing: border-box;
          position: relative;
          /* 设置内容从右到左 */
          direction: rtl;

          /* 设置滚动条的宽度和颜色 */
          &::-webkit-scrollbar {
            width: 5px;
            background-color: #f5f5f5;
          }

          /* 设置滚动条滑块的样式 */
          &::-webkit-scrollbar-thumb {
            background-color: #888;
            border-radius: 5px;
          }

          /* 设置滚动条滑块的 hover 状态样式 */
          &::-webkit-scrollbar-thumb:hover {
            background-color: #555;
          }

          .time {
            width: auto;
            padding: 5px 10px;
            box-sizing: border-box;
            font-weight: bold;
            cursor: pointer;
            direction: ltr;
          }

          .time_act {
            background-color: #49ced5;
            color: rgba(255, 255, 255, 1);
          }
        }

        .tips_box {
          width: 600px;
          text-align: end;

          .title1 {
            width: 100%;
            font-size: 46px;
            margin-bottom: 15px;
          }

          .tips {
            width: 100%;
            font-size: 14px;
            text-align: justify;
            line-height: 28px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .qywh_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    .qyln_box {
      width: 100%;
      height: auto;
      box-sizing: border-box;

      img {
        width: 100%;
        height: auto;
      }
    }

    .sdwh_box {
      width: 100%;
      height: auto;

      .title1 {
        width: 100%;
        height: 180px;
        font-size: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .img_list {
        width: 100%;
        max-width: 1400px;
        height: auto;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .img {
          width: 30%;
          border-radius: 20px;
          overflow: hidden;
          position: relative;
          cursor: pointer;

          &:hover {
            .text_box {
              opacity: 1;
            }
          }

          img {
            width: 100%;
            height: auto;
          }

          .text_box {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0%;
            opacity: 0;
            transition: all 0.3s;
            padding: 30px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            flex-direction: column;
            background-color: rgba(0, 0, 0, 0.3);
            // background-image: linear-gradient(top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
            color: rgba(255, 255, 255, 1);

            .title1 {
              width: 100%;
              font-size: 40px;
              font-weight: bold;
              display: flex;
              justify-content: flex-start;
              align-items: center;
            }

            .tips {
              width: 100%;
              font-size: 20px;
              font-weight: bold;
              text-align: justify;
            }
          }
        }
      }
    }

    .bgwh_box {
      width: 100%;
      height: auto;
      box-sizing: border-box;

      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
